import { getWith, postWith, patchWith, deleteWith } from "../axios";
import { AdvisoryReportInputDTO } from "../../pages/dtos/advisory.dtos";
import { configPromise } from "../../config/configMiddleware";

export async function GetReportCategories(): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/report-categories`;
    console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetReportNamesForCategory(
  category_id: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/reports/${category_id}`;
    console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function CreateReportRequest(data: {
  brand_id: string | undefined;
  reports_id: number;
  lead_time: number;
}) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/report-request`;
    console.log(url, data);
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetReportRequestsForOrg(
  org_id: string | undefined,
  listPage?: number,
  searchParam?: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/advisory/report-request/${org_id}/${listPage ? listPage + 1 : 1
      }/${searchParam}`;
    console.log("URL", url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetReportRequestByID(
  id: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/report-request/get-report`;
    console.log(url);
    return (await postWith<any, any>(url, { id: id })) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetAllReportRequests(
  listPage?: number,
  statusSearch?: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/advisory/all-report-request?status=${statusSearch}&limit=20&offset=${listPage ? listPage + 20 : 0
      }`;
    console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetAdvisoryRequestsDataRestriction(
  user_id: string | undefined,
  listPage?: number,
  statusSearch?: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL
      }v1/role/advisory-req-data-restriction/${user_id}?status=${statusSearch}&limit=20&offset=${listPage ? listPage + 20 : 0
      }`;
    console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function MakeAdvisoryPayment(data: {
  items: any[];
  advisory_id: number;
}) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/stripe/create-advisory-checkout-session`;
    console.log(url, data);
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function UpdateReportRequestStatus(
  requestid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/report-request-status/${requestid}`;
    return (await patchWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function UploadAdvisoryReport(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/document`;
    console.log(url, data);
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function AddReportWithCategory(data: AdvisoryReportInputDTO) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/add-report-with-category`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function AddReport(data: AdvisoryReportInputDTO) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/add-report`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function UpdateReport(
  id: string | undefined,
  data: AdvisoryReportInputDTO
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/report/${id}`;
    return (await patchWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetAllReports(): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/reports`;
    console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetReport(id: string | undefined): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/fetch-report/${id}`;
    console.log(url);
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function DeleteReport(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/advisory/report/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function deleteBrandAdvisory(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/brand-advisory/soft/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function deletePartnerAdvisory(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partner-advisory/soft/${id}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function addBrandAdvisory(data: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/brand-advisory`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updateBrandAdvisory(
  id: string | undefined,
  req: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/brand-advisory/${id}`;
    return (await patchWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function addPartnerAdvisory(data: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partner-advisory`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updatePartnerAdvisory(
  id: string | undefined,
  req: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partner-advisory/${id}`;
    return (await patchWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function uploadBrandAdvisoryReport(id: string, req: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/brand-advisory/complete/${id}`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function uploadPartnerAdvisoryReport(id: string, req: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partner-advisory/complete/${id}`;
    return (await postWith<any, any>(url, req)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getBrandAdvisoryReports(
  orgId: string | undefined,
  pageNumber: number,
  searchKey?: string,
  where?: any,
  sortOrder?: any
): Promise<any> {
  try {
    const config = await configPromise;
    const whereParam = encodeURIComponent(JSON.stringify(where));
    const req = where && Object.keys(where)?.length > 0 ? `&where=${whereParam}` : ''
    const sort = sortOrder && Object.keys(sortOrder)?.length > 0 ? `&sort=${JSON.stringify(sortOrder)}` : ''
    const url = `${config.REACT_APP_API_URL}v2/brand-advisory/fetch-by-org/${orgId}/${pageNumber}/${searchKey || ""}?${req}${sort}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getBrandAdvisoryReportbyId(
  id: string,
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/brand-advisory/${id}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getPartnerAdvisoryReports(
  pageNumber: number,
  searchKey?: string,
  where?: any,
  sortOrder?: any
): Promise<any> {
  try {
    const config = await configPromise;
    const whereParam = encodeURIComponent(JSON.stringify(where));
    const req = where && Object.keys(where)?.length > 0 ? `&where=${whereParam}` : ''
    const sort = sortOrder && Object.keys(sortOrder)?.length > 0 ? `&sort=${JSON.stringify(sortOrder)}` : ''
    const url = `${config.REACT_APP_API_URL}v2/partner-advisory/fetch-all/${pageNumber}/${searchKey || ""}?${req}${sort}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getPartnerAdvisoryReportsByPartner(
  partnerID: string | undefined,
  pageNumber: number,
  searchKey?: string,
  where?: any,
  sortOrder?: any
): Promise<any> {
  try {
    const config = await configPromise;
    const whereParam = encodeURIComponent(JSON.stringify(where));
    const req = where && Object.keys(where)?.length > 0 ? `&where=${whereParam}` : ''
    const sort = sortOrder && Object.keys(sortOrder)?.length > 0 ? `&sort=${JSON.stringify(sortOrder)}` : ''
    const url = `${config.REACT_APP_API_URL}v2/partner-advisory/fetch-by-partner/${partnerID}/${pageNumber}/${searchKey || ""}?${req}${sort}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}


export async function getPartnerAdvisoryReportbyId(
  id: string,
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partner-advisory/${id}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}